import { render } from "./GenericCarouselEditor.vue?vue&type=template&id=00af76fc&scoped=true"
import script from "./GenericCarouselEditor.vue?vue&type=script&lang=js"
export * from "./GenericCarouselEditor.vue?vue&type=script&lang=js"

import "./GenericCarouselEditor.vue?vue&type=style&index=0&id=00af76fc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00af76fc"]])

export default __exports__
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QSlider from 'quasar/src/components/slider/QSlider.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QItemLabel,QSlider,QTable,QSpace,QBtn,QTd,QCheckbox,QIcon,QTooltip,QMenu,QList,QItem,QItemSection,QSeparator});qInstall(script, 'directives', {ClosePopup});
